module.exports = __webpack_public_path__ + "static/media/1612860349382.418c6384.jpg";


//////////////////
// WEBPACK FOOTER
// ./img/1612860349382.jpg
// module id = 356
// module chunks = 0